function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillrule: "evenodd"
}, React.createElement("path", {
  fill: "currentColor",
  d: "M3.5,13 L12.5,13 L12.5,14 L3.5,14 L3.5,13 Z M8,11 C7.36533016,11 6.77966935,10.8279127 6.243,10.4837329 C5.70633065,10.1395531 5.28166823,9.67209199 4.969,9.08133562 C4.65633177,8.49057924 4.5,7.8458939 4.5,7.14726027 L4.5,2 L5.956,2 L5.956,7.14726027 C5.956,7.54794721 6.04699909,7.91780652 6.229,8.25684932 C6.41100091,8.59589211 6.66066508,8.86558119 6.978,9.06592466 C7.29533492,9.26626813 7.63599818,9.36643836 8,9.36643836 C8.36400182,9.36643836 8.70466508,9.26626813 9.022,9.06592466 C9.33933492,8.86558119 9.5913324,8.59589211 9.778,8.25684932 C9.9646676,7.91780652 10.058,7.54794721 10.058,7.14726027 L10.058,2 L11.5,2 L11.5,7.14726027 C11.5,7.8458939 11.3436682,8.49057924 11.031,9.08133562 C10.7183318,9.67209199 10.2936694,10.1395531 9.757,10.4837329 C9.22033065,10.8279127 8.63466984,11 8,11 Z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Underline.2427ca7f.svg";
export { SvgComponent as ReactComponent };